import { render, staticRenderFns } from "./addMaintenanceRecords.vue?vue&type=template&id=10779474&scoped=true"
import script from "./addMaintenanceRecords.vue?vue&type=script&lang=js"
export * from "./addMaintenanceRecords.vue?vue&type=script&lang=js"
import style0 from "./addMaintenanceRecords.vue?vue&type=style&index=0&id=10779474&prod&lang=scss"
import style1 from "./addMaintenanceRecords.vue?vue&type=style&index=1&id=10779474&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10779474",
  null
  
)

export default component.exports